module.exports = __webpack_public_path__ + "img/borussia1.4c06971b.jpg";